import { render, staticRenderFns } from "./ClientMobileRow.vue?vue&type=template&id=195c3d6d&scoped=true"
import script from "./ClientMobileRow.vue?vue&type=script&lang=js"
export * from "./ClientMobileRow.vue?vue&type=script&lang=js"
import style0 from "./ClientMobileRow.vue?vue&type=style&index=0&id=195c3d6d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "195c3d6d",
  null
  
)

export default component.exports